import { StyledTextField } from "@Components/common/byb-ds/input/styled-components";
import { TextFieldProps, useTheme } from "@mui/material";

const BybSelectTextField = ({ value, ...props }: TextFieldProps) => {
  const theme = useTheme();

  return (
    <StyledTextField
      {...props}
      value={value}
      InputProps={{
        readOnly: true,
      }}
      inputProps={{
        tabIndex: -1, // Prevents tabbing to this input
      }}
      sx={{
        ...(!!value && {
          "& .MuiFilledInput-root": {
            backgroundColor: theme.palette.dsBase.v100,
            borderColor: theme.palette.mode === "light" ? theme.palette.dsSurface.v400 : theme.palette.dsSurface.v200,
          },
        }),
      }}
    />
  );
};

export default BybSelectTextField;
